import Relation from "../../../model2/relation/relation"

// The PROJECT branch of itemRouteUrl -- the string form of
// `go-to-project-item.ts`, board view id and all.
export default function projectRouteUrl(relation: Relation): string {
    const viewId = relation.projectViewId

    return '/p/' + relation.relatedItem.id + (viewId ? '/todos/' + viewId : '')
}
